import { Router } from '@angular/router';
import { JqueryHelperService } from './../../jquery-helper.service';
import { Component, Input, OnInit } from '@angular/core';
import { Product } from '../../models/Product';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'ciu-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {

  @Input() product: Product;
  @Input() set type(type) {
    this.isWindow = type === 'window';
  }
  @Input() page: number;

  constructor(private _sanitizer: DomSanitizer,
    private jquerySrvice: JqueryHelperService, private router: Router) { }
  isWindow: boolean;
  link: string;
  defaultProductImage: any;
  ngOnInit() {
    // this.jquerySrvice.loadIMGS();
    this.defaultProductImage = this.isWindow ? this.product.images.find((img: any) => img.isDefault) : this.product.image;
    // this.defaultProductImage = this.product.images.find((img: any) => img.isDefault);
  }

  returnImageString(img) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(\'${img}\')`);
  }

  returnName(name: string, isWindow = false) {
    if (isWindow) {
      return name.length > 50 ? name.substring(0, 50) + "..." : name;
    }
    return name.length > 16 ? name.substring(0, 16) + "..." : name;
  }


  detailPage() {
    this.link = this.isWindow ? '/windowDetails' : '/productDetails';
    this.router.navigate([this.link, this.product.id], { queryParams: { page: this.page } });

    // [routerLink]="[link, product.id]"
  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/product/product.component.ts